var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg33Da542F2E3E500464F76528948Cb9Dd63728177(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2203 1798",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2002_157)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.5,
    cy: 899,
    rx: 417.5,
    ry: 215,
    fill: "var(--fill-0, #01C281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_157",
    x: 0,
    y: 0,
    width: 2203,
    height: 1798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 342,
    result: "effect1_foregroundBlur_2002_157"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33Da542F2E3E500464F76528948Cb9Dd63728177);
export default __webpack_public_path__ + "static/media/33da542f2e3e500464f76528948cb9dd63728177.75a1b606bac30efa7206bc2f92bbb320.svg";
export { ForwardRef as ReactComponent };